import { useQuery } from "@apollo/client";
import { Layout, Space, Card, Row, Col, Divider, PageHeader } from "antd";
import { GithubOutlined, MailOutlined } from "@ant-design/icons";

import { PROFILE_QUERY } from "../../helpers/graphql/profile";

export function Profile() {
  const { loading, data } = useQuery(PROFILE_QUERY);
  const profile = data?.me;

  return (
    <Layout className="content">
      <Layout.Header className="content-header">
        <Row>
          <Col span={16}>
            <PageHeader title="Profile" className="page-title" />
          </Col>
        </Row>
      </Layout.Header>
      <Layout.Content className="content-body">
        {loading ? (
          <Card loading={true} className="card-loading" />
        ) : (
          <Space
            direction="vertical"
            style={{
              width: "100%",
            }}
            size={40}
          >
            <Card className={"card-body"} title="Basic Info">
              <Row align="middle">
                <Col span={1}>
                  <GithubOutlined />
                </Col>

                <Col span={4}>Github ID</Col>
                <Col span={5}>{profile.githubId}</Col>
              </Row>
              <Divider />

              <Row align="middle">
                <Col span={1}>
                  <MailOutlined />{" "}
                </Col>

                <Col span={4}>Email</Col>
                <Col span={5}>{profile.email}</Col>
              </Row>
              <Divider />
            </Card>
          </Space>
        )}
      </Layout.Content>
    </Layout>
  );
}
